





































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Page, Pageable, Venda } from '@/models'
import axios, { CancelTokenSource } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindMotivosDeCancelamentoDaVenda } from '@/usecases/venda/FindMotivosDeCancelamentoDaVenda';
import SeletorDeMotivosDeCancelamento from '@/components/ui/SeletorDeMotivosDeCancelamento.vue'
import { MotivoCancelamento } from '@/models/MotivoCancelamento'

@Component({
	components: {
		SeletorDeMotivosDeCancelamento,
	},
})

export default class DialogoDeConfirmacaoDeCancelamentoDeVenda extends Vue  {
	@Prop() venda!: Venda;
	FindMotivosDeCancelamentoDaVenda = new FindMotivosDeCancelamentoDaVenda()

	mostra = false	
	carregando = false
	busca: string | null = null
	pageable: Pageable = {
		page: 0,
		size: 3,
	}
	pagina: Page<MotivoCancelamento> | null = null
	cancelToken: CancelTokenSource | null = null	
	motivo: MotivoCancelamento[] = []

	async abrirDialogo(item: Venda): Promise<boolean> {
		this.$forceUpdate
		this.venda = item
		this.mostra = true;
		this.motivo = []
		return this.mostra;
	}		

	get noDataMessage() {
		if (this.carregando) {
			return 'Carregando...'
		}
		if (!this.busca) {
			return 'Digite para consultar...'
		}
		return '$vuetify.noDataText'
	}

	get carregouTodosOsMotivos() {
		return this.pagina?.last || false
	}

	async pageNext() {
		this.pageable.page = !this.pageable.page
			? 1
			: this.pageable.page += 1

		await this.find()
	}

	async find() {
		if (this.cancelToken) this.cancelToken.cancel()

		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()

			this.pagina = await this.FindMotivosDeCancelamentoDaVenda.findAll({
				page: this.pageable.page || 0,
				size: this.pageable.size,
				busca: this.busca || undefined,
			},
			{
				cancelToken: this.cancelToken.token,
			})

			this.pagina?.content.forEach(motivo => {
				if (this.motivo.some(({ id }) => motivo.id === id)) return
				this.motivo.push(motivo)
			})
			this.carregando = false
		} catch (error) {
			if (axios.isCancel(error)) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	confirmarCancelamento() {
		if(this.motivo.length === 0){
			AlertModule.setError('Necessario selecionar um motivo de cancelamento')
			return 
		}

		this.$emit('confirmarCancelamento', this.motivo, this.venda);
		this.mostra = false; 
	}

	cancelar(){
		this.motivo = []
		this.mostra = false; 
	}
}
